exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-exports-tsx": () => import("./../../../src/pages/exports.tsx" /* webpackChunkName: "component---src-pages-exports-tsx" */),
  "component---src-pages-glossary-tsx": () => import("./../../../src/pages/glossary.tsx" /* webpackChunkName: "component---src-pages-glossary-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-tool-tsx": () => import("./../../../src/pages/tool.tsx" /* webpackChunkName: "component---src-pages-tool-tsx" */)
}

